





















































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'MailboxVerificationInstructionsMicrosoft',
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ColorAssistant,
      curSelection: '',
    }
  },
})
